// extracted by mini-css-extract-plugin
export default {"no":"TasterStatus_no__0UvZt","yes":"TasterStatus_yes__dyLAz","error":"TasterStatus_error__dhtrv"};